'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Label = React.forwardRef((props, ref) => {
    const { children, ...otherProps } = props;
    return (React__default['default'].createElement("label", Object.assign({ ref: ref }, otherProps), children));
});

module.exports = Label;
